import { render } from "./DirPickCentro.vue?vue&type=template&id=479a0b6d"
import script from "./DirPickCentro.vue?vue&type=script&lang=ts"
export * from "./DirPickCentro.vue?vue&type=script&lang=ts"
script.render = render

export default script